<!---- Star of Read Device-->

@if (readDevice === 'readDevice') {
  <div
    class="modal configure-feature"
    id="myModal2"
    tabindex="-1"
    role="dialog"
    >
    <div class="modal-dialog featureDialog" role="document">
      <div class="modal-content featureModalContent modal-content">
        <div class="row upload-container">
          @if (!writingDevice) {
            <div
              id="read-device-title"
              class="col-3 signifyBoldmd select-file"
              >
              Read device
            </div>
          }
          @if (writingDevice) {
            <div
              id="configure-device-title"
              class="col-3 signifyBoldmd select-file"
              >
              Configure device
            </div>
          }
          <div class="col-9"></div>
        </div>
        <div class="row box-container-margin">
          <div class="col-7 box-container">
            <br />
            @if (!hideStatus) {
              <div id="scanning-reader-status" class="signifyBoldlg center-text">
                Scanning for reader (s)...
              </div>
            }
            @if (writingDevicesContainer && removeWritingHeader) {
              <div
                id="finding-device-status"
                class="signifyBold20px center-text"
                >
                Finding a device ...
              </div>
            }
            @if (writingDevicesContainer && removeWritingHeader) {
              <div
                id="touch-device-status"
                class="signifyBooklg center-text"
                >
                Please touch device on reader...
              </div>
            }
            @if (readerLength?.length > 0 && !hideStatus) {
              <div
                class="signifyBooklg center-text spacing"
                >
                Finding
                <span class="signifyBoldlg">({{ readerLength?.length }})</span>
                reader
              </div>
            }
            @if (readerLength?.length === 0 && !hideStatus) {
              <div
                class="signifyBooklg center-text spacing"
                >
                Finding
                <span class="signifyBoldlg">({{ readerLength?.length }})</span>
                reader
              </div>
            }
            <!-- <div *ngIf="readingStatus?.serverStatus === 'Started' && !hideStatus" class="signifyBooklg center-text">Succesfully conncected with multione direct config</div> -->
            @if (customerLoader) {
              <img
                src="{{ pathVal }}{{ pathVal }}dash-spinner.gif"
                class="dash-border text-secondary custom-spinner"
                alt="" />
            }
            @if (readerData && hideStatus) {
              <div class="signifyBoldlg row">
                <div class="col-3"></div>
                @if (removeSuccessText) {
                  <div id="device-found-success" class="col-9">
                    Successfully found a device !
                  </div>
                }
              </div>
            }
            <br />
            @if (readerData && hideStatus || showData) {
              <div class="row">
                <div class="col-3"></div>
                <div class="col-9">
                  <span class="signifyBoldsm">Device: </span
                    ><span class="signifyBooksm">{{
                    readerDeviceData?.deviceMetadata?.deviceName
                  }}</span>
                  &nbsp;{{ readerDeviceData?.deviceMetadata?.deviceSwVersion }}
                </div>
              </div>
            }
            @if (readerData && hideStatus || showData) {
              <div class="row">
                <div class="col-3"></div>
                <div class="col-9">
                  <span class="signifyBoldsm">12nc: </span
                    ><span class="signifyBooksm">{{
                    readerDeviceData?.deviceMetadata?.device12nc
                  }}</span>
                </div>
              </div>
            }
            <!-- <div class="row">
            <div class="col-3"></div>
            <div class="col-9">
              <app-supported-features></app-supported-features>
            </div>
          </div> -->
          <div class="row mt-2">
            <div class="col-3"></div>
            <!--Production Info Start-->
            <div class="col-4">
              @if (readerData && hideStatus && showDeviceIDReadDC) {
                <div>
                  <span class="signifyBoldsm">Device ID: </span
                    ><span class="signifyBooksm">{{ deviceNfcId }}</span>
                  </div>
                }
                @if (isProductionInfoAvailable && readerData && hideStatus) {
                  <div>
                    <span class="signifyBoldsm">Production date: </span
                      ><span class="signifyBooksm">{{ productionDate }}</span>
                    </div>
                    <div>
                      <span class="signifyBoldsm">Production batch ID: </span
                        ><span class="signifyBooksm">{{ productionBatchId }}</span>
                      </div>
                      <div>
                        <span class="signifyBoldsm">SKU: </span
                          ><span class="signifyBooksm">{{ sku }}</span>
                        </div>
                      }
                    </div>
                    <!--Production Info End-->
                    <div class="col-5">
                      @if (!hideFeatures) {
                        <div>
                          <app-supported-features
                            [invalidFeatureData]="invalidFeatureData"
                          ></app-supported-features>
                        </div>
                      }
                    </div>
                  </div>
                  @if (customerLoaderAfter) {
                    <img
                      src="{{ pathVal }}dash-spinner.gif"
                      class="dash-border text-secondary custom-spinner"
                      alt="" />
                  }
                  @if (noReader && !specialErrorNoDatabase) {
                    <div
                      id="read-device-error-message"
                      class="center-text signifyBoldlg"
                      style="white-space: pre-line;"
                      >
                      {{ errorMessage }}
                    </div>
                  }
                  @if (!noReader && owpError) {
                    <div
                      id="read-device-owp-error-message"
                      class="center-text signifyBoldlg"
                      style="white-space: pre-line;"
                      >
                      {{ OWP_Error }}
                      <div
                        class="disconnected-img center-text signifyBoldlg"
                        >
                        <span class="signifyBooklg">| SimpleSet connected </span>
                        <img class="img-size" src="{{ pathVal }}Connected_icon.png"  alt="Connected" />
                      </div>
                    </div>
                  }
                  @if (!noReader && readerPresence) {
                    <div
                      id="read-device-reader-presence-message"
                      class="center-text signifyBoldlg"
                      style="white-space: pre-line;"
                      >
                      {{ errorMessage }}
                      <div
                        class="disconnected-img center-text signifyBoldlg"
                        >
                        <span class="signifyBooklg">| SimpleSet connected </span>
                        <img class="img-size" src="{{ pathVal }}Connected_icon.png"  alt="Connected" />
                      </div>
                    </div>
                  }
                  <!--  Special Case -->
                  @if (noReader && specialErrorNoDatabase) {
                    <div
                      class="signifyBoldlg row"
                      >
                      <div class="col-3"></div>
                      <div id="read-device-not-supported-message" class="col-9">This device is currently not supported</div>
                    </div>
                  }
                  <br />
                  @if (noReader && specialErrorNoDatabase) {
                    <div class="row">
                      <div class="col-3"></div>
                      <div class="col-9">
                        <span class="signifyBoldsm">Device: </span
                          ><span class="signifyBooksm">{{
                          readerDeviceData?.deviceMetadata?.deviceName
                        }}</span>
                        &nbsp;{{ readerDeviceData?.deviceMetadata?.deviceSwVersion }}
                      </div>
                    </div>
                  }
                  @if (noReader && specialErrorNoDatabase) {
                    <div class="row">
                      <div class="col-3"></div>
                      <div class="col-9">
                        <span class="signifyBoldsm">12nc: </span
                          ><span class="signifyBooksm">{{
                          readerDeviceData?.deviceMetadata?.device12nc
                        }}</span>
                      </div>
                    </div>
                  }
                  <br />
                  @if (noReader && specialErrorNoDatabase) {
                    <div
                      class="signifyBoldlg row"
                      >
                      <div class="col-3"></div>
                      <div id="read-device-contact-support-message" class="col-9">
                        Please contact your local Signify representative!
                      </div>
                    </div>
                  }
                  <!--  Special Case -->
                  @if (noReader && !readerPresence) {
                    <div
                      class="disconnected-img center-text signifyBoldlg"
                      >
                      <span class="signifyBooklg">| SimpleSet disconnected </span>
                      <img class="img-size" src="{{ pathVal }}disconnected_icon.png"  alt="Connected" />
                    </div>
                  }
                  @if (readerData && hideStatus) {
                    <div
                      class="disconnected-img center-text signifyBoldlg"
                      >
                      <span class="signifyBooklg">| SimpleSet connected </span>
                      <img class="img-size" src="{{ pathVal }}Connected_icon.png"  alt="Connected" />
                    </div>
                  }
                </div>
                <div class="col-5"></div>
              </div>
              <div>
                @if (!writingDevice || !isMultiDeviceChecked || (writingDevice && isMultiDeviceChecked && retryButton) || (invalidFeatureDataflag && isMultiDeviceChecked)) {
                  <div class="col-7 d-flex justify-content-end flex-row  no-padding-end button-group-no-gap">
                    @if (iscorrupt && cnfBtnClicked) {
                      <button
                        id="read-device-continue-corrupt-btn"
                        type="button"
                        class="btn retry-btn btn-color"
                        (click)="[activemodal.dismiss('Cross click'), proceed()]"
                        >
                        Continue
                      </button>
                    }
                    @if (retryButton && owpError) {
                      <button
                        id="read-device-retry-owp-btn"
                        (click)="retry()"
                        class="btn retry-btn btn-color"
                        type="button"
                        >
                        Retry
                      </button>
                    }
                    @if (retryButton && !owpError) {
                      <button
                        id="read-device-retry-btn"
                        (click)="[activemodal.dismiss('Cross click'), retry()]"
                        class="btn retry-btn btn-color"
                        type="button"
                        >
                        Retry
                      </button>
                    }
                    @if (continueRead) {
                      <button
                        id="read-device-continue-btn"
                        (click)="[activemodal.dismiss('Cross click'), continueReadClicked()]"
                        class="btn retry-btn btn-color"
                        type="button"
                        >
                        Continue
                      </button>
                    }
                    @if (!writingDevicesContainer && !retryButton && isShowCancelBtn) {
                      <button
                        id="read-device-cancel-btn"
                        (click)="[activemodal.dismiss('Cross click'), cancel()]"
                        class="btn prev-btn"
                        type="button"
                        >
                        Cancel
                      </button>
                    }
                    @if (!writingDevicesContainer && retryButton) {
                      <button
                        id="read-device-cancel-retry-btn"
                        (click)="[activemodal.dismiss('Cross click'), cancel()]"
                        class="btn retry-btn"
                        type="button"
                        >
                        Cancel
                      </button>
                    }
                    @if (writingDevicesContainer && retryButton) {
                      <button
                        id="read-device-cancel-writing-retry-btn"
                        (click)="[activemodal.dismiss('Cross click'), cancel()]"
                        class="btn retry-btn"
                        type="button"
                        >
                        Cancel
                      </button>
                    }
                  </div>
                }
                @if (canshowNextAndCancel() && isMultiDeviceChecked && writingDevice && !retryButton) {
                  <div
                    class="col-7 d-flex justify-content-end flex-row  no-padding-end button-group-no-gap">
                    <button
                      id="read-device-multi-cancel-btn"
                      type="button"
                      class="btn prev-btn"
                      (click)="[activemodal.dismiss('Cross click'), cancel()]"
                      >
                      Cancel
                    </button>
                    <button
                      id="read-device-next-device-btn"
                      type="button"
                      class="btn retry-btn btn-color next-decvice-btn"
                      (click)="nextDeviceClicked()"
                      >
                      Next device
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }

      <!---End of Read device-->
